import { gql } from 'apollo-boost';
import { useMutation } from '../';

const query = gql`
  mutation renderEmail($id: Int!) {
    renderEmail(id: $id) {
      success
      subject
      body
    }
  }
`;

export function useRenderEmail() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(query, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.renderEmail);
      }
    });
  };
  return { data, isLoading, run };
}
